var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.messages),function(message,index){return _c('div',{key:index},[_c('p',{staticStyle:{"font-size":"16px","line-height":"24px","text-align":"center"}},[_vm._v("\n      "+_vm._s(index.toString() == new Date().toISOString().slice(0, 10)
          ? "Today"
          : index.toString() ==
            new Date().getFullYear +
              "-" +
              String(new Date().getMonth() + 1).padStart(2, "0") +
              "-" +
              String(new Date().getDate() - 1).padStart(2, "0")
          ? "Yesterday"
          : new Date(index.toString()).getDate() +
            " " +
            new Date(index.toString()).toLocaleDateString("en-us", {
              month: "long",
            }) +
            (new Date().getFullYear == new Date(index.toString()).getFullYear
              ? ""
              : " " + new Date(index.toString()).getFullYear))+"\n    ")]),_vm._l((message),function(item){return _c('message-list-item',{key:item.id,attrs:{"message":item}})})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }